import swal from "@sweetalert/with-react";
import SwalAlert from "../component/SwalAlert";

const showSwalPopup = (
   titleText,
   contentText,
   confirmButtonText,
   confirmText,
   cancelText,
   callback = () => {},
   onCancel = () => {},
   showButton = true,
   showClose = false,
   message = false,
   from = "",
   isPaymentGateway = false
) => {
   return swal(
      <SwalAlert
         showClose={showClose}
         showButton={showButton}
         titleText={titleText}
         contentText={contentText}
         confirmButtonText={confirmButtonText}
         confirmText={confirmText}
         cancelText={cancelText}
         from={from}
         message={message}
         onClose={(btnData) => {
            swal.close();
            // onCancel();
         }}
         onAction={(btnData) => {
            swal.close();
            if (btnData.id === "alert-confirm-button") {
               callback();
            }
            if (btnData.id === "alert-cancel-button") {
               onCancel();
            }
         }}
         isPaymentGateway={isPaymentGateway}
      />,
      { buttons: false, closeOnClickOutside: false }
   );
};
export { showSwalPopup };
